<template>
  <div>
    <el-form
      style="margin-right: 30px"
      :rules="rules"
      ref="projectForm"
      :model="projectForm"
    >
      <el-form-item
        label="项目编号"
        :label-width="formLabelWidth"
        prop="number"
      >
        <el-input v-model="projectForm.number" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="项目名称" :label-width="formLabelWidth" prop="name">
        <el-input v-model="projectForm.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="版本号" :label-width="formLabelWidth" prop="version">
        <el-input v-model="projectForm.version" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
        label="项目关联编号"
        :label-width="formLabelWidth"
        prop="bandCode"
      >
        <el-input v-model="projectForm.bandCode" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item :label-width="formLabelWidth" label="">
        <div style="margin-right: 30px">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button
            type="primary"
            @click="confirmAction('projectForm')"
            :disabled="disableSubmit"
            >确 定</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "AddProjectForm",
  props: {
    editProject: {
      type: Object,
      default: {},
    },
  },
  watch: {
    editProject(newValue, oldValue) {
      this.projectForm = { ...newValue };
    },
  },
  mounted() {
    console.log("-----------项目编辑界面-----------");
    console.log(this.editProject);
  },
  methods: {
    closeDialog() {
      this.$emit("clickCancel");
    },
    confirmAction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.closeDialog();
          // this.clearData()
          this.$emit("clickConfirm", this.projectForm);
        } else {
          return false;
        }
      });
    },
    clearData() {
      this.projectForm.number = "";
      this.projectForm.version = "";
      this.projectForm.name = "";
    },
  },

  data() {
    return {
      disableSubmit: false,
      rules: {
        number: [
          {
            required: true,
            message: "请输入项目编号",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        version: [
          {
            required: true,
            message: "请输入项目版本号",
            trigger: "blur",
          },
        ],
      },
      formLabelWidth: "100px",
      projectForm: { ...this.editProject },
    };
  },
};
</script>

<style scoped></style>
